import styled from 'styled-components';
import SbTag from 'uiCore/SbTag/SbTag';

// Sits directly under the tab bar (which supplies its own bottom margin) and
// directly above DiffCheckerV2's toolbar row (which adds 16px of its own top
// padding), so the vertical padding here stays minimal.
export const PageHeaderStyled = styled.div`
  padding: 0 24px 0;
`;

// The active comparison mode, shown beside the main header. Sized up from
// antd's 12px Tag default so it holds its own next to a 20px heading while
// still reading as subordinate to it.
export const ModeTagStyled = styled(SbTag)`
  && {
    font-size: 14px;
    line-height: 22px;
    padding: 1px 10px;
    margin-inline-end: 0;
  }
`;
